import React from 'react';

import { useTranslation } from 'react-i18next';

import { FieldText, type FieldTextProps } from '@pkg/components';

import { type EmojiListProps } from '../../../EmojiList';

export interface SearchProps {
    darkMode?: EmojiListProps['darkMode'];
    value?: FieldTextProps['value'];
    onChange: NonNullable<FieldTextProps['onChange']>;
}

export function Search({ darkMode = false, value, onChange }: SearchProps) {
    const [translate] = useTranslation('emoji');

    // TODO: Switch to `<FieldSearch />` once we support `tiny` size.
    return (
        <FieldText
            autoFocus
            id="EmojiPicker-Search"
            type="search"
            value={value}
            placeholder={translate('searchPlaceholder')}
            size="tiny"
            theme={darkMode ? 'dark' : 'light'}
            onChange={onChange}
        />
    );
}
